/**
 * Anonym browser-ID til gæste-baseret dedup.
 *
 * Gemmer et UUID i localStorage['sb_guest_id']. Bruges udelukkende af
 * reactions-endpointet (og lignende gæste-features senere) så samme
 * browser ikke kan like samme guide flere gange.
 *
 * IKKE en tracking-id — gemmes lokalt, sendes kun til vores egen backend
 * via X-Guest-Id header, forlader aldrig localStorage medmindre bruger
 * rydder browserdata.
 */
const STORAGE_KEY = 'sb_guest_id';

function _generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for ældre browsere.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Hent (eller opret ved første kald) det persistente guest-id.
 * SSR-safe: returnerer null hvis localStorage ikke er tilgængeligt.
 */
export function getGuestId() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = _generateUuid();
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch (_e) {
    return null;
  }
}

/**
 * Peek — returnér nuværende id UDEN at oprette et nyt hvis det ikke findes.
 * Bruges til at afgøre om migration ved login er relevant.
 */
export function peekGuestId() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (_e) {
    return null;
  }
}
